import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import Card1 from "../../assets/Slice 1.png";
import Card2 from "../../assets/Slice 2.png";


gsap.registerPlugin(ScrollTrigger);

export default function PicDivider() {
  const leftCard = useRef(null);
  const rightCard = useRef(null);
   
useEffect(() => {
  const mm = ScrollTrigger.matchMedia();

  /* =========================
     MOBILE ONLY
  ========================= */
  mm.add("(max-width: 768px)", () => {
    gsap.set([leftCard.current, rightCard.current], {
  force3D: true,
});

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#details",
        start: "top center",
        end: "45% center",
        scrub: true,
        onEnter: () => document.body.classList.add("cards-flipped"),
        onLeaveBack: () => document.body.classList.remove("cards-flipped"),
      },
    });

    // 1️⃣ Right card drops down
    tl.to(rightCard.current, {
      y: 300, // adjust drop distance
      ease: "none",
    });

    // 2️⃣ Both cards flip in place
  tl.to(leftCard.current, {
  rotateY: 180,
  duration: 0.4,
  ease: "power2.inOut",
},">");


  tl.to(rightCard.current, {
  rotateY: 180,
  duration: 0.4,
  ease: "power2.inOut",
},"<");

  });

  /* =========================
     DESKTOP ONLY
  ========================= */
  mm.add("(min-width: 769px)", () => {
    gsap.to(leftCard.current, {
      rotateY: 180,
      scrollTrigger: {
        trigger: "#details",
        start: "45% center",
        end: "60% center",
        scrub: true,
      },
    });

    gsap.to(rightCard.current, {
      rotateY: -180,
      scrollTrigger: {
        trigger: "#details",
        start: "45% center",
        end: "60% center",
        scrub: true,
      },
    });
  });

  return () => mm.revert();
}, []);

  return (
    <section id="details" className="details">
      {/* HEADER ROW (isolated) */}
      <div className="details-header">
        <h1>Wedding Details</h1>
      </div>

      {/* CARDS ROW */}
      <div className="details-cards">
        <div className="col left">
          <div className="card" ref={leftCard}>
            <div className="card-face card-front">
              <img src={Card1} alt="" />
            </div>
            <div className="card-face card-back">
              <h4>Schedule</h4>
              <p>✨Ceremony: <br />3:00 PM</p>
              <p>✨Photos & Cocktail Hour: Immediately following the ceremony</p>
              <p>✨Reception:<br />6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="col right">
          <div className="card" ref={rightCard}>
            <div className="card-face card-front">
              <img src={Card2} alt="" />
            </div>
            <div className="card-face card-back">
              <h4>Formal Attire</h4>
              <p>✨Wedding Colors:<b> White, <span style={{color: "#da9100"}}>Gold</span> and <span style={{color: "#2f4c39"}}>Emerald Green</span></b></p>
              <p>✨Ladies: <br />Gold attire is encouraged</p>
              <p>✨Gentlemen:<br />Emerald green tie/pocket squares are encouraged</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

